import { useAuth } from "@/contexts/AuthContext";
import { useImpersonation } from "@/hooks/useImpersonation";
import { Button } from "@/components/ui/button";
import { toast } from "@/utils/toast";

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser } = useAuth();
  const { stop, loading } = useImpersonation();

  if (!isImpersonating) return null;

  const name =
    [impersonatedUser?.firstName, impersonatedUser?.lastName]
      .filter(Boolean)
      .join(" ") ||
    impersonatedUser?.email ||
    "user";

  const onStop = async () => {
    try {
      await stop();
    } catch {
      toast.warning("Could not stop impersonation.");
    }
  };

  return (
    // A session lasts four hours and grants an identity that is not yours, so
    // the way out has to be on screen at all times: the root pins it, with the
    // other banners, above the navbar and the admin top bar (Jira NAV-227). In
    // flow (not fixed) so it never covers the page it pushes down.
    <div
      role="alert"
      className="flex items-center justify-between gap-4 bg-destructive px-4 py-2 text-sm text-destructive-foreground"
    >
      {/* Says what the session can and cannot do: the acting role and BU are
          the target's, but every write is refused (useImpersonationGuard).
          "Blocked" rather than "disabled" on purpose — most controls that
          write are greyed out, the rest refuse with a message on click, and
          claiming the stronger word would be false for the second group. */}
      <span>Impersonating {name}. Viewing only, changes are blocked.</span>
      {/* The `outline` variant sets a background but no foreground, so the
          label inherited the banner's white `text-destructive-foreground` and
          was invisible on the button's white face until hover swapped in
          `accent-foreground`. Both states are pinned here instead. */}
      <Button
        variant="outline"
        disabled={loading}
        onClick={onStop}
        className="shrink-0 bg-background text-destructive hover:bg-background/90 hover:text-destructive"
      >
        Stop impersonating
      </Button>
    </div>
  );
}
